export const routingConstants = {
  dashboard: "/",
  dashboardRedirect: "/dashboard",
  profile: "/profile",

  createJob: "/create-job",


  candidateCreate: "/candidate/create",

  invitedCandidate: "/invited-candidate",
  unfilledContracts: "/unfilled-contract",

  appliedCandidate: "/applied-candidate",
  bookedCandidate: "/booked-candidate",
  workedCandidate: "/worked-candidate",

  invoice: "/invoice/list",


  login: "login",
  logout: "/logout",
  otpVerificationRoute: "otp_verification/:id/:email",
  otpVerification: (id, email) => {
    return `/otp_verification/${id}/${email}`;
  },

  downloads: "/downloads",

  candidateDetailRoute: "candidate/details/:id",
  candidateDetail: (id) => {
    return `/candidate/details/${id}`;
  },

  contractDetailRoute: "contract/details/:id",
  contractDetail: (id) => {
    return `/contract/details/${id}`;
  },

  assignedTimesheet: "/timesheet/assigned",
  submittedTimesheet: "/timesheet/submitted",
  authorisedTimesheet: "/timesheet/authorised",
  terminatedTimesheet: "/timesheet/terminated",

  // //user
  clientUsers: "/users/list",

  // // Roles - Pages
  clientRole: "/user/roles",
  clientAddRole: "/role/add",
  clientEditRoleRoute: "role/edit/:id",
  clientEditRole: (id) => {
    return `/role/edit/${id}`;
  },

  candidateEdit: "candidate/edit/:id", // NEW
  candidateEditRoute: (id) => {
    return `/candidate/edit/${id}`;
  }, // NEW

  clientAnnouncement: "/announcement",

};

export const serviceRouteConstants = {
  // auth
  verifyEmail: "verify_email",
  validate_email: "validate_user_email",
  login: "login",
  verifyLoginOtp: "verify_otp",
  resendLoginOtp: "resend_login_otp",
  forgotPassword: "forgotpassword",

  clientAllowPublishJob: "client_allow_publish_job",

  impersonateClient: "impersonate_user",

  // // header
  generalSearch: "get_general_search_result",
  getQrCode: "get_qr_code",

  // downloads
  downloads: "download_report_list",

  // // createjob
  jobTemplates: "get_job_templates",

  fieldData: "get_field_data",
  candidateDropdownData: "get_candidate_dropdown_data", // NEW
  addEditCandidateDetails: "add_edit_candidate_details",

  // 1st step - fetch rates.
  listOfRate: "get_list_of_client_percentage_rates",
  multipleListOfClientRate: "get_list_of_client_rates_based_on_role",
  dayWiseRate: "check_time_based_rates",
  saveCreateJob: "add_new_contract",
  deleteJobTemplate: "delete_job_template",
  fetchBankShortListCandidate: "get_candidates_list_for_contract",
  fetchAppLocumShortListCandidate:
    "get_candidates_list_for_self_applocum_contract",

  // // clientprofile
  profileData: "view_profile",
  getSecurityCode: "generatepin",
  updateProfileData: "edit_profile",
  updateProfileImage: "update_profile_image",
  getContactProfileData: "get_client_user_profile",
  updateClientContactData: "update_client_user_profile",
  getAllClientContactData: "get_client_contact_person_list",
  updateClientContactPrimary: "update_primary_contact",

  // // clientnotification
  notificationHistory: "get_notification_history",
  markAsRead: "mark_read_notification",
  markAllAsRead: "mark_all_read_notification",
  deleteNotification: "delete_notification",
  deleteAllNotification: "delete_all_notification",

  // // clientinvoice
  invoice: "get_invoice_list",
  candidatePayIncvoice: "get_candidate_invoice_list",
  invoiceCount: "get_invoice_count",
  UpdateCandidatePayStatus: "update_candidate_pay_invoice_status",

  // // clientdashboard
  candidateTypeCount: "dashboard_count",
  shiftCalendar: "get_shifts_by_month",
  upComingBookings: "upcomming_jobs",

  // // Timesheet
  timesheetCount: "get_timesheet_count",
  // // timesheetList : route('client.timesheet_list'),
  assignedTimesheetList: "get_assigned_timesheet_list",
  authorisedTimesheetList: "get_authorised_timesheet_list",
  submittedTimesheetList: "get_submitted_timesheet_list",
  terminatedTimesheetList: "get_terminated_timesheet_list",

  // // client-unfilled-contracts
  unfilledContracts: "get_unfilled_contract_list",
  unfilledDeleteContracts: "delete_contract_unfilled_list", // REMOVE LATER
  unfilledGetShiftCalander: "get_shift_calander", // REMOVE LATER
  unfilledGetEditManageShiftsContract: "get_shift_details_for_edit", // REMOVE LATER
  unfilledUpdateEditManageShiftsContract: "update_appconnect_shift", // REMOVE LATER
  unfilledDeletemanageShiftContract: "delete_appconnect_shift", // REMOVE LATER
  unfilledGetAddShiftDetails: "get_shift_details_for_add", // REMOVE LATER
  unfilledAddNewManageShiftsContract: "add_new_appconnect_shift",
  unfilledProposeCandiateForContract: "propose_candidate_for_contract",
  checkJobCretariaForCandidate: "check_job_cretaria_for_candidate",
  fetchCandidatesForProposeCandidate: "get_candidates_list_for_contract",
  getContractShiftData: "get_contract_shift_data",

  // clientcandidatedetail
  candidateDetail: "get_candidate_details",
  // candidateCalendarShifts: "get_candidate_calendar_shifts",
  resendComplianceNotificationToCandidate: "send_upload_rtw_reminder",
  onOffOverRideComplianceForBankCandidate: "on_off_override_compliance",
  getCandidateComplianceUrl: "get_document_url",

  // // clientcontractdetail
  contractDetail: "get_contract_details",
  contractShifts: "get_unfilled_contract_shifts",
  contractApplicationList: "get_contract_applicant_list",
  contractTerminatedShifts: "get_contract_terminated_shifts",

  // // clientcandidate - invited
  checkInvitedBankCandidate: "check_candidate_email_for_invitation",
  resendInvitedBankCandidate: "send_email_to_candidate_invitation",
  invitedCandidate: "get_invited_candidate_list",
  sendCandidateInvitation: "send_candidate_invitation",
  importCandidateResume: "upload_bulk_candidate_resume",
  autoApproveBankCandidate: "approve_deny_auto_booked_status_of_candidates",
  removeInvitedCandidate: "remove_bank_candidate",

  // // clientcandidate - applied
  appliedCandidate: "get_applied_candidate_list",
  appliedCandidateShifts: "get_applied_shift_data",

  // // clientcandidate - worked
  workedCandidate: "get_worked_candidate_list",
  workedShifts: "get_worked_contract_shifts",

  // // clientcandidate - booked
  bookedCandidate: "get_booked_candidate_list",
  bookedShifts: "get_booked_contract_shifts",
  bookedMergeContractShifts: "get_merge_contract_list",
  bookedSelectedMergeContract: "merge_multiple_contract",

  // // Apprve Reject Candidate
  approveCandidate: "approve_candidate",
  rejectCandidate: "reject_candidate",
  approveSelectedShifts: "approve_selected_shifts",

  // // Get Filter Data
  getFilterData: "get_filter_data",

  // // Amendment
  approveAmendment: "approve_amendment",
  rejectAmendment: "reject_amendment",
  // showEditAmendment: route("client.show_edit_amendment"),
  shotAdjustAmendment: "show_adjust_amendment",
  saveAdjustAmendment: "save_adjust_amendment",

  // // clientcandidatedetail
  candidateDocuments: "get_candidate_documents",
  editBankCandidateDocuments: "upload_candidate_documents",

  // // Chat
  chatUsers: "get_chat_candidate_list",
  chatHistory: "get_user_chat_history",
  sendChatAttanchment: "chat_attachment",
  markChatAsRead: "mark_chat_as_read",
  sendNotificationToCandidate: "send_notification_to_candidate",
  getTotalUnreadCount: "get_unread_counts",
  saveChatTemplate: "save_chat_template",
  getChatTemplate: "get_chat_templates",
  offlineMessage: "offline_message",

  // chat broadcast
  createBroadcast: "store_group_data",
  getBroadcastChatGrpDetails: "get_group_details",
  addCandidateToBroadCastGroup: "add_user_to_group",
  deleteCandidateToBroadCastGroup: "delete_user_from_group",
  deleteBroadCastGroup: "delete_group",

  // // Client Users
  clientUsers: "get_agency_user_list",
  clientUserListCount: "get_agency_user_count",
  addClientUsers: "add_agency_user",
  fetchNewUserRolesData: "get_agency_user_roles",
  fetchClientUserEdit: "edit_agency_user",
  updateClientUser: "update_agency_user",
  deleteClientUser: "delete_agency_user",
  resendEmailToClientUsers: "resend_login_instruction_to_agency_user",

  // //Client Roles
  clientRoleList: "get_agency_user_role_list",
  clientRoleAdd: "add_agency_user_role",
  clientRoleEdit: "edit_agency_user_role",
  clientRoleDelete: "delete_agency_user_role",
  updateClientRoles: "update_agency_user_role",
  agencyPermissions: "get_agency_permissions",

  // //client branches
  clientBranchList: "get_client_branches_data",

  // //client setting
  clientBankPublishHours: "get_client_settings",
  clientBankPublishHoursUpdate: "update_client_settings",
  clientSetNewUnfilledBankPublishContract: "add_timer_in_contract",

  // exports
  exportApplied: "export_applied_candidate_list",
  exportContractShifts: "export_contract_shifts",
  exportContractTerminatedShifts: "export_contract_terminated_shifts",
  exportCandidateWorkedHistory: "export_candidate_worked_history",
  exportCandidateUpcomingBooking: "export_candidate_upcoming_booking",
  exportBooked: "export_booked_candidate_list",
  exportWorked: "export_worked_candidate_list",
  exportUnfilled: "export_unfilled_contract_list",
  exportInvoices: "export_agency_invoice",
  exportTerminated: "export_terminated_data",
  exportAuthorised: "export_authorised_data",
  exportCompliance: "export_appconnect_candidate_compliance",
  exportCandidatePayInvoice: "export_invoice_candidate_pay_list",
  exportAppLocumInvoice: "export_applocum_invoices_list",

  //client announcment
  clientUpdateNewAnnouncement: "update_announcement",
  clientAllAnnouncementList: "get_app_announcements",

  //client report/feedback
  clientReportFeedback: "add_appconnect_feedback",



  // client- user-guide
  updateTourGuide: "update_tour_guide",
  bulkUploadShifts: "import_appconnect_shifts",

  ///////////
  getCandidateList: "get_candidate_list",
  updateCandidatePaymentDetails: "update_candidate_payment_details",
  getCandidateDetails: "get_candidate_details",
  getCandidateDocuments: "get_candidate_documents",
  uploadCandidateDocuments: "upload_candidate_documents",
  getDocumentUrl: "get_document_url",
  signOffJob: "signoff_job",
  getUnPaidTimesheet: "get_invoice_adjustment_model",
  saveInvoiceAdjustment: "save_invoice_adjustment",
};
